/* Mint style — nút "Add to Cart" của trang sản phẩm mt-product (không chuyển trang). Bê từ theme Capitol cũ (gv-add.js).
   Adding… → Added (1 giây) → trở lại. Báo cho giỏ hàng Horizon (số trên icon, ngăn kéo giỏ hàng) bằng đúng sự kiện chuẩn mà theme dùng,
   rồi mở giỏ hàng nhanh mt-minicart (khung mới Shopify trả kèm, khỏi tải thêm); tắt giỏ nhanh → mở ngăn kéo giỏ gốc Horizon
   (nếu bật trong section và Cart type = Drawer). Không có JS thì form vẫn gửi bình thường tới /cart/add.
   Nghe 'submit' ở pha capture trên window: chặn mặc định TRƯỚC bộ theo dõi của Shopify (Web Pixels),
   nếu không Shopify đếm 2 lần product_added_to_cart (1 lần do form submit, 1 lần do request /cart/add.js). */
const busy = new WeakSet();

async function cartEvent() {
  try { return (await import('@shopify/events')).CartLinesUpdateEvent || null; } catch (_) { return null; }
}

window.addEventListener('submit', async (e) => {
  const form = e.target instanceof HTMLFormElement && e.target.matches('form[data-mt-add]') ? e.target : null;
  if (!form) return;
  e.preventDefault();
  const btn = form.querySelector('.mt-pd__atc');
  if (!btn || btn.disabled || busy.has(form)) return;
  busy.add(form);
  const label = btn.querySelector('.mt-pd__atc-t') || btn;
  const err = form.querySelector('.mt-pd__err');
  const T = btn.dataset;
  if (err) { err.hidden = true; err.textContent = ''; }
  btn.classList.add('is-busy');
  btn.setAttribute('aria-disabled', 'true');
  label.textContent = T.adding;

  let errTimer = 0;
  const reset = (ms) => setTimeout(() => {
    label.textContent = btn.disabled ? T.sold : T.add;
    btn.classList.remove('is-busy');
    btn.removeAttribute('aria-disabled');
    busy.delete(form);
  }, ms);
  const fail = (msg) => {
    if (err) {
      err.textContent = msg || T.error; err.hidden = false;
      clearTimeout(errTimer); errTimer = setTimeout(() => { err.hidden = true; }, 10000);
    }
    reset(0);
  };

  const data = new FormData(form);
  const qty = Number(data.get('quantity')) || 1;
  const mini = window.MTMini || null;   // giỏ hàng nhanh (sections/mt-minicart.liquid)
  const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  if (mini) ids.push(mini.sectionId);
  if (ids.length) data.set('sections', [...new Set(ids)].join(','));

  const Ev = await cartEvent();
  const deferred = Ev && Ev.createPromise ? Ev.createPromise() : null;
  if (deferred) {
    form.dispatchEvent(new Ev({
      action: 'add', context: 'product',
      lines: [{ merchandiseId: String(data.get('id')), quantity: qty }],
      promise: deferred.promise,
    }));
  }
  const settle = (cart, detail) => {
    if (!deferred) return;
    let c;
    try { c = cart && Ev.createCartFromAjaxResponse ? Ev.createCartFromAjaxResponse(cart) : undefined; } catch (_) { c = undefined; }
    deferred.resolve({ cart: c, detail: Object.assign({ items: cart ? cart.items : [], source: 'mt-product', sourceId: form.id || '', productId: form.dataset.productId }, detail) });
  };
  const getCart = () => fetch((form.dataset.cart || '/cart').replace(/\/$/, '') + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => null);

  try {
    const res = await fetch(form.action.replace(/\/$/, '') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data,
    });
    let json = {};
    try { json = await res.json(); } catch (_) {}
    if (!res.ok || json.status) {
      settle(await getCart(), { didError: true, itemCount: 0 });
      fail(json.description || json.message);
      return;
    }
    settle(await getCart(), { didError: false, itemCount: qty, sections: json.sections });
    label.textContent = T.added;
    reset(1000);
    if (mini) {
      if (form.hasAttribute('data-open-cart') && mini.openOnAdd) mini.open(json.sections && json.sections[mini.sectionId], btn);
      else mini.refresh();
    } else if (form.hasAttribute('data-open-cart')) {
      const drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) {
        try { drawer.open(); } catch (_) {}
      }
    }
  } catch (x) {
    settle(null, { didError: true, itemCount: 0 });
    fail();
  }
}, true);
